import type { ChartRequest } from '../aiChatTypes';

export const DATE_RANGES = 'CUSTOM';

// Minimal type shape compatible with OpenAI Realtime "tools"
type JSONSchemaType = 'string' | 'number' | 'integer' | 'boolean' | 'array' | 'object';

export interface JSONSchemaProperty {
  type?: JSONSchemaType;
  description?: string;
  enum?: string[];
  items?: JSONSchemaProperty;
  properties?: Record<string, JSONSchemaProperty>;
  required?: string[];
  additionalProperties?: boolean;
  [key: string]: unknown;
}

export interface ToolDefinition {
  name: string;
  description: string;
  parameters: {
    type: JSONSchemaType;
    properties?: Record<string, JSONSchemaProperty>;
    items?: JSONSchemaProperty;
    required?: string[];
    additionalProperties?: boolean;
  };
}

// Tool message from LLM
export interface ToolMessage {
  callId: string;
  name: string;
  arguments: string;
}

// Tool response format
export interface ToolResponse<T = any> {
  callId: string;
  type: 'response.function_call.output.done';
  name: string;
  output: T;
}

// Simple tool handler - just message and send function
export type ToolHandler = (msg: ToolMessage) => Promise<any> | any;

// Legacy compatibility
export type ToolHandlers = Record<string, ToolHandler>;

export type ChartTransformer = (output: unknown) => ChartRequest | ChartRequest[] | null;

export type ToolEntry = {
  definition: ToolDefinition;
  handler: ToolHandler;
  chartTransformer?: ChartTransformer;
};

export type LlmToolsCategory = {
  id?: string;
  name: string;
  parentId?: string | null;
  isDeleted?: boolean;
  isNotUserAssignable?: boolean;
  isExcludedFromCategoryList?: boolean;
  usageType?: string | null;
  // ...other fields you might have
};

export type LlmToolsCategoryDict = Record<string, LlmToolsCategory | undefined>;

export type LlmToolsCategoryForAI = Pick<LlmToolsCategory, 'name' | 'parentId'> & { id: string };
